module.exports = __webpack_public_path__ + "img/ao.4e70ca9.svg";